import Icon from '../components/Icon.vue'

Icon.register({
  'book-dead': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M272 136C280.8 136 288 128.8 288 120S280.8 104 272 104 256 111.2 256 120 263.2 136 272 136zM448 358.4V25.6C448 9.6 438.4 0 422.4 0H96C41.6 0 0 41.6 0 96V416C0 470.4 41.6 512 96 512H422.4C435.2 512 448 502.4 448 486.4V470.4C448 464 444.8 457.6 438.4 451.2 435.2 435.2 435.2 390.4 438.4 377.6 444.8 374.4 448 368 448 358.4zM240 56C284.2 56 320 84.6 320 120 320 140.9 307.3 159.2 288 170.9V184C288 192.8 280.8 200 272 200H208C199.2 200 192 192.8 192 184V170.9C172.7 159.2 160 140.9 160 120 160 84.6 195.8 56 240 56zM129.1 233.8A8-8 0 0 0 124.8 223.3L131.1 208.7A8-8 0 0 0 141.7 204.4L240 246.6 338.4 204.4C342.4 202.7 347.1 204.6 348.9 208.7L355.2 223.3A8-8 0 0 0 351 233.8L280.6 264 350.9 294.1A8-8 0 0 0 355.1 304.6L348.9 319.4A8-8 0 0 0 338.3 323.6L240 281.4 141.7 323.5A8-8 0 0 0 131.1 319.3L124.8 304.6A8-8 0 0 0 129.1 294.1L199.4 264 129.1 233.8zM380.8 448H96C76.8 448 64 435.2 64 416S80 384 96 384H380.8V448zM208 136C216.8 136 224 128.8 224 120S216.8 104 208 104 192 111.2 192 120 199.2 136 208 136z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/book-dead.js
// module id = ViYE
// module chunks = 144